import { createFileRoute } from '@tanstack/react-router';
import { OrdersPage } from '@/features/table-ordering/pages/orders-page';

export const Route = createFileRoute('/_app/orders')({ component: OrdersPage });
